/**
 * Mosterd Quick-Add Handler
 * Shared click handler for all Mosterd product card quick-add buttons.
 * - Single variant: direct add-to-cart via AJAX
 * - Multi-variant: opens Dwell's quick-add modal with variant picker
 */
(function () {
  if (window.__mdQuickAddInit) return;
  window.__mdQuickAddInit = true;

  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.md-quick-add-btn');
    if (!btn) return;
    e.preventDefault();

    var variantCount = parseInt(btn.dataset.variantCount || '1', 10);
    var productUrl = btn.dataset.productUrl;

    /* Multi-variant: fetch product page and open Dwell's quick-add modal */
    if (variantCount > 1 && productUrl) {
      var dialog = document.querySelector('#quick-add-dialog');
      var modalContent = document.getElementById('quick-add-modal-content');
      if (!dialog || !modalContent) {
        window.location.href = productUrl;
        return;
      }

      btn.disabled = true;
      btn.textContent = '\u2026';

      fetch(productUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = doc.querySelector('[data-product-grid-content]');
          if (grid) {
            modalContent.innerHTML = '';
            modalContent.appendChild(document.importNode(grid, true));
            if (typeof dialog.showDialog === 'function') {
              dialog.showDialog();
            }
          } else {
            window.location.href = productUrl;
          }
          btn.textContent = '+';
          btn.disabled = false;
        })
        .catch(function () {
          window.location.href = productUrl;
        });
      return;
    }

    /* Single variant: direct add to cart */
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = '\u2026';

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '\u2713';
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { data: { source: 'quick-add', variantId: variantId } } }));
        setTimeout(function () {
          btn.textContent = '+';
          btn.disabled = false;
        }, 1200);
      })
      .catch(function () {
        btn.textContent = '!';
        setTimeout(function () {
          btn.textContent = '+';
          btn.disabled = false;
        }, 1500);
      });
  });
})();
